import create from "zustand";
import { TalhaoJustificados } from "../interfaces/Talhao";

interface ModalState {
  id?: string;
  talhaoJustificado: TalhaoJustificados | null;
  isOpenView: boolean;
  isOpenEdit: boolean;
  ids: Set<string>;
  status: string;
 
  setId: (args: string) => void;
  setTalhaoJustificado: (args: TalhaoJustificados | null) => void;
  setIsOpenView: (args: boolean) => void;
  setIsOpenEdit: (args: boolean) => void;
  setIds: (updater: Set<string> | ((prev: Set<string>) => Set<string>)) => void;
  setStatus: (args: string) => void;
}

const useModalGestaoJustificativa = create<ModalState>((set) => ({
  id: '',
  isOpenView: false,
  isOpenEdit: false,
  talhaoJustificado: null,
  ids: new Set<string>(),
  status: '',

  setId: (id) => {
    set(state => ({ id }));
  },
  setIsOpenView: (isOpenView) => {
    set(state => ({ isOpenView }));
  },
  setIsOpenEdit: (isOpenEdit) => {
    set(state => ({ isOpenEdit }));
  },
  setTalhaoJustificado: (talhaoJustificado) => {
    set(state => ({ talhaoJustificado }));
  },

  setIds: (updater) => {
    set((state) => {
      const newIds = typeof updater === 'function' 
        ? updater(state.ids) 
        : updater;
      return { ids: newIds };
    });
  },

  setStatus: (status) => {
    set(state => ({ status }));
  },
  
}));

export default useModalGestaoJustificativa;
